import { SentryError } from "@amzn/sentry-fetch";

/** sessionStorage key marking that we already reloaded once for a Midway session failure. */
const MIDWAY_RELOAD_MARKER_KEY = "itshophw.midwaySessionReloadPending";

/** Returns whether SentryFetch could not establish a usable Midway session. */
export function isMidwaySessionUnavailable(error: unknown): boolean {
  return error instanceof Error && error.message === SentryError.NO_MIDWAY_SESSION;
}

/**
 * Marks that we are reloading the page to recover from a Midway session failure.
 * AuthLoading checks this marker so a lingering failure is shown immediately after
 * reload, instead of requiring another React Query call to fail first -- which
 * would otherwise let a persistent failure trigger repeated reloads.
 */
export function markMidwaySessionReloadPending(): void {
  window.sessionStorage.setItem(MIDWAY_RELOAD_MARKER_KEY, "true");
}

/** Returns whether a reload was already triggered for a Midway session failure. */
export function isMidwaySessionReloadPending(): boolean {
  return window.sessionStorage.getItem(MIDWAY_RELOAD_MARKER_KEY) === "true";
}

/** Clears the reload marker. Called once authorization succeeds again. */
export function clearMidwaySessionReloadPending(): void {
  window.sessionStorage.removeItem(MIDWAY_RELOAD_MARKER_KEY);
}
